import store from './store'
import TicketSaleSelectors from '../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../selectors/bus-seat-selection.selectors'

const getState = (store) => ({
	groupGoing: store.ticketSale.groupGoing,
	groupReturn: store.ticketSale.groupReturn,
	serviceGoing: store.ticketSale.serviceGoing,
	serviceReturn: store.ticketSale.serviceReturn,
	originIbgeCode: store.ticketSale.originIbgeCode,
	busSeatsGoing: store.busSeatSelection.busSeatsGoing,
	poltronasIda: store.busSeatSelection.poltronasIda,
	originLocalityId: store.ticketSale.originLocalityId,
	raceDateGoing: store.ticketSale.raceDateGoing,
	raceDateReturn: store.ticketSale.raceDateReturn,
	destinationIbgeCode: store.ticketSale.destinationIbgeCode,
	destinationLocalityId: store.ticketSale.destinationLocalityId,
	tripGoing: TicketSaleSelectors.getTripGoing(store),
	tripReturn: TicketSaleSelectors.getTripReturn(store),
	isBusSelectionGoingStep: TicketSaleSelectors.isBusSelectionGoingStep(store),
	ordemViagemIda: TicketSaleSelectors.getOrdemViagemIda(store),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	conexao: store.conexao,
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
})

function getDeselectParams(busSeat) {
	const {
		tripGoing,
		groupGoing,
		serviceGoing,
		selectedBusSeatsGoing,
		isBusSelectionGoingStep,
		selectedPoltonasIda,
		conexao,
	} = getState(store.getState())

	if (conexao != null && conexao.ehConexaoIda && isBusSelectionGoingStep) {
		const { transactionId, bookingCode, provider, originId, destinationId } =
			selectedPoltonasIda.find(
				({ number }) => number == busSeat,
				({ ordem }) => ordem == conexao.ordemViagemIda - 1
			)

		const conexaoTrechoAtual =
			conexao.conexaoIda.trecho[parseInt(conexao.ordemViagemIda) - 1]

		return {
			busSeat,
			bookingCode,
			transactionId,
			group: conexaoTrechoAtual.group,
			service: conexaoTrechoAtual.service,
			tripDate: conexaoTrechoAtual.departure,
			classCode: conexaoTrechoAtual.classCode,
			busCompany: conexaoTrechoAtual.enterprise,
			scheduleKey: conexaoTrechoAtual.scheduleKey,
			raceDate: conexaoTrechoAtual.raceDate,
			provider,
			originId,
			destinationId,
		}
	} else {
		if (isBusSelectionGoingStep) {
			const {
				transactionId,
				bookingCode,
				originId,
				provider,
				destinationId,
			} = selectedBusSeatsGoing.find(({ number }) => number == busSeat)
			return {
				transactionId,
				bookingCode,
				busSeat,
				originId,
				group: groupGoing,
				destinationId,
				service: serviceGoing,
				tripDate: tripGoing.departure,
				classCode: tripGoing.classCode,
				busCompany: tripGoing.enterprise,
				scheduleKey: tripGoing.scheduleKey,
				raceDate: tripGoing.raceDate,
				provider,
			}
		} else {
			return getDeselectParamsReturn(busSeat)
		}
	}
}

function getDeselectParamsReturn(busSeat) {
	const { tripReturn, groupReturn, serviceReturn, selectedBusSeatsReturn } =
		getState(store.getState())

	const { transactionId, bookingCode, provider, originId, destinationId } =
		selectedBusSeatsReturn.find(({ number }) => number == busSeat)
	return {
		busSeat,
		bookingCode,
		transactionId,
		group: groupReturn,
		service: serviceReturn,
		tripDate: tripReturn.departure,
		classCode: tripReturn.classCode,
		busCompany: tripReturn.enterprise,
		scheduleKey: tripReturn.scheduleKey,
		raceDate: tripReturn.raceDate,
		provider,
		originId,
		destinationId,
	}
}

const busSeatSelectionHelper = { getDeselectParams, getDeselectParamsReturn }

export default busSeatSelectionHelper
